import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ExtRepliedTo } from "state/detailedposting/state";
import { getDetailedPostingId } from "state/detailedposting/selectors";
import { Icon, msReplySolid } from "ui/material-symbols";
import RepliedTo from "ui/comment/RepliedTo";
import "./CommentRepliedTo.css";

interface Props {
    repliedTo: ExtRepliedTo | null | undefined;
    previousId: string | null;
}

export default function CommentRepliedTo({repliedTo, previousId}: Props) {
    const {t} = useTranslation();

    const postingId = useSelector(getDetailedPostingId);

    if (postingId == null || !repliedTo) {
        return null;
    }
    if (repliedTo.id === previousId) {
        return (
            <div className="replied-to-previous" title={t("reply-prev-comment")}>
                <Icon icon={msReplySolid} size="1.2em"/>
            </div>
        );
    }
    return (
        <RepliedTo postingId={postingId} commentId={repliedTo.id} ownerName={repliedTo.name}
                   ownerFullName={repliedTo.fullName ?? null} ownerSourceUri={repliedTo.sourceUri ?? null}
                   headingHtml={repliedTo.headingHtml ?? ""} unset={false}/>
    );
}
